import { render, staticRenderFns } from "./ChooseClientAddress.vue?vue&type=template&id=4c69a8be&scoped=true&"
import script from "./ChooseClientAddress.vue?vue&type=script&lang=js&"
export * from "./ChooseClientAddress.vue?vue&type=script&lang=js&"
import style0 from "./ChooseClientAddress.vue?vue&type=style&index=0&id=4c69a8be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c69a8be",
  null
  
)

export default component.exports